// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__rq0pC","info":"Panel_info__gUhLE","btns":"Panel_btns__FjlTf","button":"Panel_button__owbG1"};